/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { useFloating, useHover, safePolygon, useInteractions, FloatingNode, FloatingPortal, useFloatingNodeId, shift, offset, } from '@floating-ui/react';
import style from './HeaderMenuButton.module.scss';
export function HeaderSubMenuButton({ button, children }) {
    const [isOpen, setIsOpen] = useState(false);
    const nodeId = useFloatingNodeId();
    const { x, y, strategy, refs, context } = useFloating({
        nodeId,
        placement: 'right-start',
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            shift(),
            offset({
                crossAxis: -10,
            }),
        ],
    });
    const hover = useHover(context, {
        handleClose: safePolygon({ restMs: 50 }),
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([hover]);
    return (React.createElement("div", null,
        React.createElement("button", { className: style.menuButtonLink, type: "button", ref: refs.setReference, ...getReferenceProps() }, button),
        React.createElement(FloatingNode, { id: nodeId },
            React.createElement(FloatingPortal, null, isOpen && (React.createElement("div", { className: style.dropdown, ref: refs.setFloating, ...getFloatingProps(), style: {
                    position: strategy,
                    top: y ?? 0,
                    left: x ?? 0,
                    width: 'max-content',
                } }, children))))));
}
